import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as badgeSt from './badge.module.scss'

export interface ILocationBadgeProps extends AtfTreatmentProps {
  location?: string
}

export const Location = ({ location, atfTreatment }: ILocationBadgeProps) => (
  location &&
  (<Badge use={badges.TEXT} {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})}>
    <span data-automation-id="location-badge">{location}</span>
  </Badge>) || null
)
